import type { Icon, IconProps, IconWeight } from '@phosphor-icons/react'
// One file per glyph, never the package barrel: the barrel re-exports all
// ~1,500 icons, which Vitest loads in full on every cold screen import
// (~0.6 s idle, 3 s+ under the loaded pre-deploy gate).
import { ArrowCounterClockwiseIcon } from '@phosphor-icons/react/dist/csr/ArrowCounterClockwise'
import { ArrowDownIcon } from '@phosphor-icons/react/dist/csr/ArrowDown'
import { ArrowLeftIcon } from '@phosphor-icons/react/dist/csr/ArrowLeft'
import { ArrowRightIcon } from '@phosphor-icons/react/dist/csr/ArrowRight'
import { ArrowsClockwiseIcon } from '@phosphor-icons/react/dist/csr/ArrowsClockwise'
import { ArrowsDownUpIcon } from '@phosphor-icons/react/dist/csr/ArrowsDownUp'
import { ArrowSquareOutIcon } from '@phosphor-icons/react/dist/csr/ArrowSquareOut'
import { ArrowUpIcon } from '@phosphor-icons/react/dist/csr/ArrowUp'
import { BankIcon } from '@phosphor-icons/react/dist/csr/Bank'
import { BellIcon } from '@phosphor-icons/react/dist/csr/Bell'
import { BookOpenIcon } from '@phosphor-icons/react/dist/csr/BookOpen'
import { BuildingsIcon } from '@phosphor-icons/react/dist/csr/Buildings'
import { CalculatorIcon } from '@phosphor-icons/react/dist/csr/Calculator'
import { CalendarIcon } from '@phosphor-icons/react/dist/csr/Calendar'
import { CameraIcon } from '@phosphor-icons/react/dist/csr/Camera'
import { CaretDownIcon } from '@phosphor-icons/react/dist/csr/CaretDown'
import { CaretLeftIcon } from '@phosphor-icons/react/dist/csr/CaretLeft'
import { CaretRightIcon } from '@phosphor-icons/react/dist/csr/CaretRight'
import { ChartBarIcon } from '@phosphor-icons/react/dist/csr/ChartBar'
import { ChartLineUpIcon } from '@phosphor-icons/react/dist/csr/ChartLineUp'
import { ChatsCircleIcon } from '@phosphor-icons/react/dist/csr/ChatsCircle'
import { CheckIcon } from '@phosphor-icons/react/dist/csr/Check'
import { CheckCircleIcon } from '@phosphor-icons/react/dist/csr/CheckCircle'
import { CheckSquareIcon } from '@phosphor-icons/react/dist/csr/CheckSquare'
import { CircleNotchIcon } from '@phosphor-icons/react/dist/csr/CircleNotch'
import { ClipboardTextIcon } from '@phosphor-icons/react/dist/csr/ClipboardText'
import { ClockIcon } from '@phosphor-icons/react/dist/csr/Clock'
import { ClockCounterClockwiseIcon } from '@phosphor-icons/react/dist/csr/ClockCounterClockwise'
import { CloudIcon } from '@phosphor-icons/react/dist/csr/Cloud'
import { CloudArrowUpIcon } from '@phosphor-icons/react/dist/csr/CloudArrowUp'
import { CodeIcon } from '@phosphor-icons/react/dist/csr/Code'
import { CopyIcon } from '@phosphor-icons/react/dist/csr/Copy'
import { CreditCardIcon } from '@phosphor-icons/react/dist/csr/CreditCard'
import { CubeIcon } from '@phosphor-icons/react/dist/csr/Cube'
import { CurrencyDollarIcon } from '@phosphor-icons/react/dist/csr/CurrencyDollar'
import { DatabaseIcon } from '@phosphor-icons/react/dist/csr/Database'
import { DesktopTowerIcon } from '@phosphor-icons/react/dist/csr/DesktopTower'
import { DiamondIcon } from '@phosphor-icons/react/dist/csr/Diamond'
import { DotsSixVerticalIcon } from '@phosphor-icons/react/dist/csr/DotsSixVertical'
import { DotsThreeIcon } from '@phosphor-icons/react/dist/csr/DotsThree'
import { DownloadSimpleIcon } from '@phosphor-icons/react/dist/csr/DownloadSimple'
import { EnvelopeIcon } from '@phosphor-icons/react/dist/csr/Envelope'
import { EyeIcon } from '@phosphor-icons/react/dist/csr/Eye'
import { FactoryIcon } from '@phosphor-icons/react/dist/csr/Factory'
import { FileMagnifyingGlassIcon } from '@phosphor-icons/react/dist/csr/FileMagnifyingGlass'
import { FilePlusIcon } from '@phosphor-icons/react/dist/csr/FilePlus'
import { FileTextIcon } from '@phosphor-icons/react/dist/csr/FileText'
import { FolderIcon } from '@phosphor-icons/react/dist/csr/Folder'
import { FunnelIcon } from '@phosphor-icons/react/dist/csr/Funnel'
import { GearIcon } from '@phosphor-icons/react/dist/csr/Gear'
import { GearSixIcon } from '@phosphor-icons/react/dist/csr/GearSix'
import { GiftIcon } from '@phosphor-icons/react/dist/csr/Gift'
import { GlobeIcon } from '@phosphor-icons/react/dist/csr/Globe'
import { GridFourIcon } from '@phosphor-icons/react/dist/csr/GridFour'
import { HammerIcon } from '@phosphor-icons/react/dist/csr/Hammer'
import { HeartIcon } from '@phosphor-icons/react/dist/csr/Heart'
import { HourglassIcon } from '@phosphor-icons/react/dist/csr/Hourglass'
import { HouseIcon } from '@phosphor-icons/react/dist/csr/House'
import { ImageIcon } from '@phosphor-icons/react/dist/csr/Image'
import { InfoIcon } from '@phosphor-icons/react/dist/csr/Info'
import { KanbanIcon } from '@phosphor-icons/react/dist/csr/Kanban'
import { KeyIcon } from '@phosphor-icons/react/dist/csr/Key'
import { LinkIcon } from '@phosphor-icons/react/dist/csr/Link'
import { ListIcon } from '@phosphor-icons/react/dist/csr/List'
import { ListBulletsIcon } from '@phosphor-icons/react/dist/csr/ListBullets'
import { ListChecksIcon } from '@phosphor-icons/react/dist/csr/ListChecks'
import { ListNumbersIcon } from '@phosphor-icons/react/dist/csr/ListNumbers'
import { LockIcon } from '@phosphor-icons/react/dist/csr/Lock'
import { LockOpenIcon } from '@phosphor-icons/react/dist/csr/LockOpen'
import { MagicWandIcon } from '@phosphor-icons/react/dist/csr/MagicWand'
import { MagnifyingGlassIcon } from '@phosphor-icons/react/dist/csr/MagnifyingGlass'
import { MapPinIcon } from '@phosphor-icons/react/dist/csr/MapPin'
import { MicrophoneIcon } from '@phosphor-icons/react/dist/csr/Microphone'
import { MinusIcon } from '@phosphor-icons/react/dist/csr/Minus'
import { NotePencilIcon } from '@phosphor-icons/react/dist/csr/NotePencil'
import { PackageIcon } from '@phosphor-icons/react/dist/csr/Package'
import { PaletteIcon } from '@phosphor-icons/react/dist/csr/Palette'
import { PaperclipIcon } from '@phosphor-icons/react/dist/csr/Paperclip'
import { PaperPlaneTiltIcon } from '@phosphor-icons/react/dist/csr/PaperPlaneTilt'
import { ParagraphIcon } from '@phosphor-icons/react/dist/csr/Paragraph'
import { PathIcon } from '@phosphor-icons/react/dist/csr/Path'
import { PauseIcon } from '@phosphor-icons/react/dist/csr/Pause'
import { PencilSimpleIcon } from '@phosphor-icons/react/dist/csr/PencilSimple'
import { PlayIcon } from '@phosphor-icons/react/dist/csr/Play'
import { PlugIcon } from '@phosphor-icons/react/dist/csr/Plug'
import { PlugsIcon } from '@phosphor-icons/react/dist/csr/Plugs'
import { PlusIcon } from '@phosphor-icons/react/dist/csr/Plus'
import { PlusCircleIcon } from '@phosphor-icons/react/dist/csr/PlusCircle'
import { PrinterIcon } from '@phosphor-icons/react/dist/csr/Printer'
import { PulseIcon } from '@phosphor-icons/react/dist/csr/Pulse'
import { QuestionIcon } from '@phosphor-icons/react/dist/csr/Question'
import { ReceiptIcon } from '@phosphor-icons/react/dist/csr/Receipt'
import { RulerIcon } from '@phosphor-icons/react/dist/csr/Ruler'
import { ScrollIcon } from '@phosphor-icons/react/dist/csr/Scroll'
import { ShieldIcon } from '@phosphor-icons/react/dist/csr/Shield'
import { ShieldCheckIcon } from '@phosphor-icons/react/dist/csr/ShieldCheck'
import { ShieldWarningIcon } from '@phosphor-icons/react/dist/csr/ShieldWarning'
import { ShoppingBagIcon } from '@phosphor-icons/react/dist/csr/ShoppingBag'
import { ShoppingBagOpenIcon } from '@phosphor-icons/react/dist/csr/ShoppingBagOpen'
import { ShoppingCartIcon } from '@phosphor-icons/react/dist/csr/ShoppingCart'
import { SignOutIcon } from '@phosphor-icons/react/dist/csr/SignOut'
import { SlidersHorizontalIcon } from '@phosphor-icons/react/dist/csr/SlidersHorizontal'
import { SparkleIcon } from '@phosphor-icons/react/dist/csr/Sparkle'
import { SquaresFourIcon } from '@phosphor-icons/react/dist/csr/SquaresFour'
import { StackIcon } from '@phosphor-icons/react/dist/csr/Stack'
import { StarIcon } from '@phosphor-icons/react/dist/csr/Star'
import { StopCircleIcon } from '@phosphor-icons/react/dist/csr/StopCircle'
import { StorefrontIcon } from '@phosphor-icons/react/dist/csr/Storefront'
import { TagIcon } from '@phosphor-icons/react/dist/csr/Tag'
import { TargetIcon } from '@phosphor-icons/react/dist/csr/Target'
import { TestTubeIcon } from '@phosphor-icons/react/dist/csr/TestTube'
import { TextAlignCenterIcon } from '@phosphor-icons/react/dist/csr/TextAlignCenter'
import { TextAlignLeftIcon } from '@phosphor-icons/react/dist/csr/TextAlignLeft'
import { TextAlignRightIcon } from '@phosphor-icons/react/dist/csr/TextAlignRight'
import { TextBIcon } from '@phosphor-icons/react/dist/csr/TextB'
import { TextHThreeIcon } from '@phosphor-icons/react/dist/csr/TextHThree'
import { TextHTwoIcon } from '@phosphor-icons/react/dist/csr/TextHTwo'
import { TextItalicIcon } from '@phosphor-icons/react/dist/csr/TextItalic'
import { TextTIcon } from '@phosphor-icons/react/dist/csr/TextT'
import { TextUnderlineIcon } from '@phosphor-icons/react/dist/csr/TextUnderline'
import { TrashIcon } from '@phosphor-icons/react/dist/csr/Trash'
import { TrayIcon } from '@phosphor-icons/react/dist/csr/Tray'
import { TruckIcon } from '@phosphor-icons/react/dist/csr/Truck'
import { UploadSimpleIcon } from '@phosphor-icons/react/dist/csr/UploadSimple'
import { UserIcon } from '@phosphor-icons/react/dist/csr/User'
import { UserCircleIcon } from '@phosphor-icons/react/dist/csr/UserCircle'
import { UserMinusIcon } from '@phosphor-icons/react/dist/csr/UserMinus'
import { UserPlusIcon } from '@phosphor-icons/react/dist/csr/UserPlus'
import { UsersIcon } from '@phosphor-icons/react/dist/csr/Users'
import { WalletIcon } from '@phosphor-icons/react/dist/csr/Wallet'
import { WarehouseIcon } from '@phosphor-icons/react/dist/csr/Warehouse'
import { WarningIcon } from '@phosphor-icons/react/dist/csr/Warning'
import { WarningOctagonIcon } from '@phosphor-icons/react/dist/csr/WarningOctagon'
import { XIcon } from '@phosphor-icons/react/dist/csr/X'
import { XCircleIcon } from '@phosphor-icons/react/dist/csr/XCircle'

/**
 * PEXIFY's semantic icon vocabulary.
 *
 * Consumers ask for a product meaning—not a vendor glyph—so the visual
 * language can evolve globally without editing every shell or feature.
 */
export const pexIconRegistry = {
  account: UserCircleIcon,
  activity: PulseIcon,
  add: PlusIcon,
  appearance: PaletteIcon,
  addFunds: PlusCircleIcon,
  assignUser: UserPlusIcon,
  banking: BankIcon,
  billing: CreditCardIcon,
  boards: KanbanIcon,
  brand: PaletteIcon,
  calculator: CalculatorIcon,
  calendar: CalendarIcon,
  catalog: TagIcon,
  caretDown: CaretDownIcon,
  caretLeft: CaretLeftIcon,
  caretRight: CaretRightIcon,
  close: XIcon,
  cloud: CloudIcon,
  code: CodeIcon,
  copy: CopyIcon,
  dashboard: SquaresFourIcon,
  database: DatabaseIcon,
  danger: XCircleIcon,
  decrease: MinusIcon,
  distribution: PaperPlaneTiltIcon,
  documents: FileTextIcon,
  download: DownloadSimpleIcon,
  dragHandle: DotsSixVerticalIcon,
  edit: PencilSimpleIcon,
  email: EnvelopeIcon,
  emptyProducts: PackageIcon,
  externalLink: ArrowSquareOutIcon,
  factory: FactoryIcon,
  favorite: StarIcon,
  fileSearch: FileMagnifyingGlassIcon,
  filter: FunnelIcon,
  folder: FolderIcon,
  fulfillment: TruckIcon,
  global: GlobeIcon,
  help: QuestionIcon,
  home: HouseIcon,
  image: ImageIcon,
  inbox: TrayIcon,
  info: InfoIcon,
  insights: ChartLineUpIcon,
  inventory: WarehouseIcon,
  integration: PlugIcon,
  key: KeyIcon,
  layers: StackIcon,
  link: LinkIcon,
  list: ListBulletsIcon,
  location: MapPinIcon,
  lock: LockIcon,
  menu: ListIcon,
  messages: ChatsCircleIcon,
  microphone: MicrophoneIcon,
  more: DotsThreeIcon,
  notifications: BellIcon,
  operations: ClipboardTextIcon,
  orders: ShoppingCartIcon,
  organization: BuildingsIcon,
  bundles: CubeIcon,
  package: CubeIcon,
  packageUnavailable: XCircleIcon,
  path: PathIcon,
  pause: PauseIcon,
  payments: CreditCardIcon,
  planning: TargetIcon,
  preview: EyeIcon,
  premium: DiamondIcon,
  printing: PrinterIcon,
  products: PackageIcon,
  production: HammerIcon,
  referral: GiftIcon,
  receipt: ReceiptIcon,
  measurements: RulerIcon,
  refresh: ArrowsClockwiseIcon,
  resume: PlayIcon,
  search: MagnifyingGlassIcon,
  security: ShieldIcon,
  servers: DesktopTowerIcon,
  settings: GearIcon,
  settlement: ReceiptIcon,
  shopping: ShoppingBagIcon,
  sparkle: SparkleIcon,
  store: StorefrontIcon,
  stopRecording: StopCircleIcon,
  success: CheckCircleIcon,
  tag: TagIcon,
  taskComplete: CheckSquareIcon,
  template: KanbanIcon,
  time: ClockIcon,
  trash: TrashIcon,
  typography: TextTIcon,
  upload: UploadSimpleIcon,
  userRemoved: UserMinusIcon,
  users: UsersIcon,
  wallet: WalletIcon,
  warning: WarningIcon,
  workflow: PathIcon,
  write: NotePencilIcon,
  newDocument: FilePlusIcon,
  experiment: TestTubeIcon,
  monetization: SlidersHorizontalIcon,
  navCatalog: GridFourIcon,
  navInsights: ChartLineUpIcon,
  navInventory: WarehouseIcon,
  navListings: ListBulletsIcon,
  navOrders: ShoppingBagOpenIcon,
  navOverview: HouseIcon,
  navProducts: CubeIcon,
  navSettings: GearSixIcon,
  navStores: StorefrontIcon,
  navWallet: WalletIcon,
  learning: BookOpenIcon,
  // Slice 1 of the Lucide -> PexIcon migration (components/ + features/seller/).
  alignCenter: TextAlignCenterIcon,
  alignLeft: TextAlignLeftIcon,
  alignRight: TextAlignRightIcon,
  attachment: PaperclipIcon,
  back: ArrowLeftIcon,
  camera: CameraIcon,
  chart: ChartBarIcon,
  check: CheckIcon,
  checklist: ListChecksIcon,
  critical: WarningOctagonIcon,
  disconnect: PlugsIcon,
  forward: ArrowRightIcon,
  gridView: SquaresFourIcon,
  heading2: TextHTwoIcon,
  heading3: TextHThreeIcon,
  history: ClockCounterClockwiseIcon,
  like: HeartIcon,
  listNumbered: ListNumbersIcon,
  loading: CircleNotchIcon,
  magic: MagicWandIcon,
  money: CurrencyDollarIcon,
  notes: ScrollIcon,
  paragraph: ParagraphIcon,
  pending: HourglassIcon,
  reset: ArrowCounterClockwiseIcon,
  securityAlert: ShieldWarningIcon,
  signOut: SignOutIcon,
  sortAscending: ArrowUpIcon,
  sortDescending: ArrowDownIcon,
  sortable: ArrowsDownUpIcon,
  textBold: TextBIcon,
  textItalic: TextItalicIcon,
  textUnderline: TextUnderlineIcon,
  unlock: LockOpenIcon,
  uploadCloud: CloudArrowUpIcon,
  user: UserIcon,
  verified: ShieldCheckIcon,
} as const satisfies Record<string, Icon>

export type PexIconName = keyof typeof pexIconRegistry
export type { IconProps as PexVendorIconProps, IconWeight as PexVendorIconWeight }
